module.exports = __webpack_public_path__ + "assets/img/bg1.a3976c61.jpg";